import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const ManageNotifications = ({ token, features }) => {
    const [credits, setCredits] = useState(0);
    const [logo, setLogo] = useState('');
    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [message, setMessage] = useState({ text: '', type: '' });

    // Form inputs
    const [title, setTitle] = useState('');
    const [body, setBody] = useState('');
    const [url, setUrl] = useState('');
    const [file, setFile] = useState(null);
    const [imagePreview, setImagePreview] = useState('');

    const hasPush = features?.has_push_notification;

    useEffect(() => {
        if (hasPush) {
            fetchCredits();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasPush]);

    if (features && !features.has_push_notification) {
        return (
            <div className="admin-card" style={{ textAlign: 'center', padding: '60px 40px' }}>
                <Link to="/manage_v2_secure_auth/" className="sticky-back-btn">
    <i className="fas fa-arrow-left"></i> Back to Dashboard
</Link>
                <div style={{ width: '72px', height: '72px', background: 'linear-gradient(135deg, #fef3c7, #fde68a)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
                    <i className="fas fa-bell" style={{ fontSize: '1.8rem', color: '#f59e0b' }} />
                </div>
                <h2 style={{ margin: '0 0 10px 0' }}>Push Notifications</h2>
                <p style={{ color: 'var(--text-color-secondary)', maxWidth: '400px', margin: '0 auto 28px', lineHeight: '1.65' }}>Send instant messages to customers who scanned your QR code — announce offers, events or daily specials for free. Available on the Paid Plan.</p>
                <Link to="/manage_v2_secure_auth/subscription" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '12px 28px', background: 'var(--primary-orange, #ea580c)', color: '#fff', borderRadius: '50px', fontWeight: '700', textDecoration: 'none', boxShadow: '0 4px 14px rgba(234,88,12,0.3)' }}>
                    <i className="fas fa-crown" /> Upgrade to Unlock
                </Link>
            </div>
        );
    }

    const fetchCredits = async () => {
        try {
            const res = await fetch('https://menu.searchisend.in/apimenu/v2/v2_notifications.php?action=fetch_credits', {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await res.json();
            if (data.success) {
                setCredits(data.credits);
                setLogo(data.logo_url || 'https://searchisend.in/scalogo.png');
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const handleFileChange = (e) => {
        const f = e.target.files[0];
        if (f) {
            setFile(f);
            const reader = new FileReader();
            reader.onload = ev => setImagePreview(ev.target.result);
            reader.readAsDataURL(f);
        } else {
            setFile(null);
            setImagePreview('');
        }
    };

    const handleSend = async (e) => {
        e.preventDefault();
        if (credits <= 0) return;

        setSending(true);
        const formData = new FormData();
        formData.append('action', 'send');
        formData.append('title', title);
        formData.append('message', body);
        formData.append('url', url);
        if (file) formData.append('image', file);

        try {
            const res = await fetch('https://menu.searchisend.in/apimenu/v2/v2_notifications.php', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` },
                body: formData
            });
            const data = await res.json();
            if (data.success) {
                setMessage({ text: data.message, type: 'success' });
                setTitle(''); setBody(''); setUrl(''); setFile(null); setImagePreview('');
                fetchCredits(); // Deduct count locally
            } else {
                setMessage({ text: data.message, type: 'error' });
            }
        } catch (err) {
            setMessage({ text: 'Error sending notification', type: 'error' });
        } finally {
            setSending(false);
            setTimeout(() => setMessage({ text: '', type: '' }), 4000);
        }
    };

    const inputStyle = { width: '100%', padding: '12px', border: '1px solid var(--border-color)', borderRadius: '5px', boxSizing: 'border-box' };

    return (
        <div className="admin-card">
            <Link to="/manage_v2_secure_auth/" className="sticky-back-btn">
                <i className="fas fa-arrow-left"></i> Back to Dashboard
            </Link>
            <h1 style={{marginTop: '0'}}>Send Push Notification</h1>
            <p>Send a message directly to devices of users who have subscribed to your menu's notifications.</p>

            {message.text && (
                <div style={{padding: '15px', borderRadius: '5px', marginBottom: '20px', fontWeight: '500', backgroundColor: message.type === 'success' ? '#d4edda' : '#f8d7da', color: message.type === 'success' ? '#155724' : '#721c24'}}>
                    {message.text}
                </div>
            )}

            <div style={{backgroundColor: 'var(--bg-color)', padding: '20px', borderRadius: '10px', textAlign: 'center', marginBottom: '30px'}}>
                <h3 style={{marginTop: 0}}>Remaining Notification Credits</h3>
                <p style={{fontSize: '3em', fontWeight: '700', color: 'var(--primary-orange)', margin: 0}}>{loading ? '-' : credits}</p>
            </div>

            {credits > 0 ? (
                <form onSubmit={handleSend} style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                    <div>
                        <label style={{display: 'block', fontWeight: '500', marginBottom: '5px'}}>Notification Title (Required)</label>
                        <input type="text" required value={title} onChange={e => setTitle(e.target.value)} placeholder="e.g. Special Weekend Deal" style={inputStyle} />
                    </div>
                    <div>
                        <label style={{display: 'block', fontWeight: '500', marginBottom: '5px'}}>Message (Required)</label>
                        <textarea required rows="4" value={body} onChange={e => setBody(e.target.value)} placeholder="e.g. Get 20% off all orders." style={inputStyle} />
                    </div>
                    <div>
                        <label style={{display: 'block', fontWeight: '500', marginBottom: '5px'}}>Clickable Link (Optional)</label>
                        <input type="url" value={url} onChange={e => setUrl(e.target.value)} placeholder="https://..." style={inputStyle} />
                    </div>
                    <div>
                        <label style={{display: 'block', fontWeight: '500', marginBottom: '5px'}}>Banner Image (Optional)</label>
                        <input type="file" accept="image/*" onChange={handleFileChange} style={inputStyle} />
                    </div>

                    {/* LIVE PREVIEW CONTAINER */}
                    <div style={{border: '2px dashed var(--border-color)', padding: '20px', borderRadius: '10px', marginTop: '10px'}}>
                        <h4 style={{marginTop: 0}}>Live Preview</h4>
                        <div style={{backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', borderRadius: '12px', padding: '15px', display: 'flex', gap: '12px', maxWidth: '400px', margin: 'auto'}}>
                            <img src={logo || 'https://via.placeholder.com/40'} alt="Icon" style={{width: '40px', height: '40px', borderRadius: '8px', objectFit: 'cover'}} />
                            <div style={{flexGrow: 1}}>
                                <p style={{fontWeight: '600', color: '#111', margin: '0 0 2px 0'}}>{title || '[Your Title Here]'}</p>
                                <p style={{fontSize: '0.9em', color: '#555', margin: 0}}>{body || '[Your message will appear here.]'}</p>
                                {imagePreview && (
                                    <div style={{width: '100%', aspectRatio: '2/1', overflow: 'hidden', borderRadius: '8px', marginTop: '10px', backgroundColor: '#f0f0f0'}}>
                                        <img src={imagePreview} alt="Banner" style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <button type="submit" disabled={sending} style={{padding: '12px', backgroundColor: 'var(--primary-orange)', color: 'white', fontWeight: '600', borderRadius: '50px', border: 'none', cursor: 'pointer', fontSize: '1.05em'}}>
                        {sending ? 'Sending...' : 'Send Notification (1 Credit)'}
                    </button>
                </form>
            ) : (
                <div style={{padding: '20px', backgroundColor: '#f8d7da', color: '#721c24', borderRadius: '10px', textAlign: 'center'}}>
                    <p style={{fontWeight: '600'}}>You have no more credits left to send notifications.</p>
                </div>
            )}
        </div>
    );
};

export default ManageNotifications;
